/** Access credentials live only in this page's memory. Refresh is HttpOnly. */
let accessToken: string | null = null;
export const readStoredAccessToken = (): string | null => accessToken;
export const writeAccessToken = (value: string | null): void => { accessToken = value; };
export const resolveRequestAuthorization = (explicitAuthorization?: unknown): string | null => {
  if (accessToken) return `Bearer ${accessToken}`;
  return typeof explicitAuthorization === 'string' && /^Bearer\s+\S/i.test(explicitAuthorization)
    ? explicitAuthorization : null;
};
